import { forwardRef } from 'react'
import { Icon } from '../../core'
import { NotificationSeverities } from '../../core/Notification'

interface NotificationIconProps {
  severity: NotificationSeverities
}

function getIconName(severity: NotificationSeverities) {
  switch (severity) {
    case 'info':
      return 'info'
    case 'success':
      return 'check_circle'
    case 'warning':
      return 'error'
    case 'error':
      return 'warning'
    case 'neutral':
      return 'info'
    default:
      return 'error'
  }
}

export const NotificationIcon = forwardRef<SVGSVGElement, NotificationIconProps>((props, ref) => {
  void ref
  const { severity = 'info' } = props

  return <Icon color="inherit" size={'small'} style={{ marginRight: 10 }} icon={getIconName(severity)} />
})
